<template>
    <div>
        <!--<nav-back :dataTit="'企业详情'"></nav-back>-->
        <!--<def-hn></def-hn>-->
        <div class="index-break">
            <span class="iconfont el-icon-close" @click="goBackHistory()">关闭预览模式</span>
        </div>
        <div class="banner-all" :style="'height: ' + activityView.banner_height + 'px'">
            <mt-swipe :auto="4000">
                <mt-swipe-item v-for="(item, index) in activityView.banner" :key="index">
                    <img :src="item.src" class="banner-img"/>
                </mt-swipe-item>
            </mt-swipe>
        </div>
        <div>
            <div class="company-msg">
                <div class="company-logo">
                    <img :src="qview.logo"/>
                </div>
                <div class="company-name">{{qview.title}}</div>
            </div>
            <div class="company-nums">
                <div>
                    <span class="iconfont icon-kaiyanjing"></span>
                    <span>0</span>
                </div>
                <div class="iconfont icon-fenxiang" @click="goyanzheng"></div>
            </div>
            <ul class="bont-ul">
                <li class="active">企业介绍</li>
                <li @click="showContact">联系方式</li>
            </ul>
            <!--企业介绍-->
            <div class="introduce" :class="{active1: introduceShow}" ref="introduce">
                <Cont :content="qview.content"></Cont>
            </div>
            <div class="bont1" @click="goShow" v-if="!introduceShow">展开</div>
            <div class="bont11" @click="introduceShow = false" v-if="introduceShow && souShow">收起</div>
            <div class="def-height"></div>
            <ul class="bont-ul">
                <li :class="{active: showProduct}" @click="showProduct=1">参展产品</li>
                <li :class="{active: !showProduct}" @click="showProduct=0">资料下载</li>
            </ul>
            <Cont :content="qview.product" v-show="showProduct===1"></Cont>
            <ul class="file-list" v-show="showProduct===0">
              <li v-for="(item,index) in qview.file" :key="index" @click="getData(item.url)">
                  {{item.name}}
              </li>
            </ul>
        </div>
        <div style="height: 50px"></div>
        <div class="bakc-bont">
            <div class="bakc-bont-left" @click="goBack">返回首页</div>
            <div class="bakc-bont-right" @click="goBackList">返回企业列表</div>
        </div>
    </div>
</template>

<script>
  import { Toast, MessageBox } from 'mint-ui'
  import NavBack from "../public/navBack"
  import DefHn from "../public/defHn"
  import Cont from '../public/editor/content'
  import Share from "../public/share"
  import breadcrumb from "../public/breadcrumb"
  let wx = require('weixin-js-sdk')

  export default {
    name: "comview",
    components: {
      NavBack, DefHn, Cont, Share, breadcrumb},
    data () {
      return {
        showProduct: 1,
        qview: {},
        shareShow: false,
        isUrl: '',
        shareMsg: '',
        activityView: {},
        breadList: [
          {
            name: '首页',
            url: '/'
          },
          {
            name: '企业列表',
            url: ''
          }
        ],
        introduceShow: false,
        isShow: false,
        divHeight: '',
        souShow: true
      }
    },
    watch: {
      isShow () {
        if (this.isShow) {
          window.scrollTo(0,0)
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = 'auto'
        }
      },
      introduceShow () {
        if (this.introduceShow === false) {
          window.scrollTo(0,0)
        }
      }
    },
    created () {
      // WeixinJSBridge.call('showOptionMenu');
      window.addEventListener('scroll', this.windowScroll)
      let that = this
      this.$g.ajax({
        method: 'post',
        path: 'events/view',
        data: {
          id: this.$route.query.eid
        },
        cbSuccess(data) {
          document.title = data.memo.title
          that.activityView = data.memo
          sessionStorage.setItem('activityView', JSON.stringify(data.memo))
          that.isUrl = 'company/view?eid=' + data.memo.id + '&aid=' + that.$route.query.aid
          that.breadList[1].url = './index?eid=' + data.memo.id
          that.breadList[0].url = '/?id=' + data.memo.id
              that.getView()
        },
        cbError(data) {
          let msg = data.msg
          Toast({
            message: msg,
            position: 'bottom',
            duration: 3000
          })
        }
      })
    },
    methods: {
      goBackHistory() {
        if (window.WeixinJSBridge) {
          // 在微信中
          // 这个可以关闭安卓系统的手机
          document.addEventListener(
            'WeixinJSBridgeReady',
            function () {
              //window.WeixinJSBridge.call('closeWindow')
              history.back(-1)
            },
            false
          )
          // 这个可以关闭ios系统的手机
          //window.WeixinJSBridge.call('closeWindow')
          history.back(-1)
        } else {
          // 在其他浏览器中
          window.close()
        }
      },
      goShow () {
        this.introduceShow = true
      },
      windowScroll() {
        this.divHeight = this.$refs.introduce.offsetHeight
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop >= (this.divHeight - 120)) {
          this.souShow = false
        } else {
          this.souShow = true
        }
      },
      bodyScroll (event){
        event.preventDefault()
      },
      goyanzheng () {
        Toast({
          message: '预览模式下无法分享',
          duration: 3000
        })
      },
      getView () {
        let that = this
        let activityView = JSON.parse(sessionStorage.getItem('activityView'))
        this.$g.ajax({
          method: 'post',
          path: 'eventCompanies/preview',
          data: {
            eid: this.$route.query.eid,
            aid: this.$route.query.aid
          },
          cbSuccess(data) {
            that.qview = data.memo
            that.shareMsg = data.memo.title + ' | ' + activityView.title
            console.log(that.shareMsg)
            let obj = {
              name: data.memo.title,
              url: ''
            }
            that.breadList.push(obj)
          },
          cbError(data) {
            let msg = data.msg
            Toast({
              message: msg,
              duration: 3000
            })
          }
        })
      },
      goBack () {
        // this.$route.query.eid
        this.$router.push({
          path: '/',
          query: {
            id: this.$route.query.eid
          }
        })
      },
      goBackList () {
        this.$router.push({
          path: '/company/index',
          query: {
            eid: this.$route.query.eid
          }
        })
      },
      showContact () {
        MessageBox({
          title: '联系方式',
          message: this.qview.contact
        });
      },
      getData (path) {
        Toast({
          message: '预览模式无法下载文件',
          duration: 3000
        })
        return false
        let ua = navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          this.isShow = true
        } else {
          window.open(path)
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.windowScroll)
    }
  }
</script>

<style lang="scss" scoped>
    .file-list{
      margin: 10px 0;
      padding: 5px 0;
      border-top: 1px solid #cccccc;
      li{
        width: 100%;
        padding: 8px 0 8px 20px;
        cursor: pointer;
        color: #7f9698;
        list-style: square;
        box-sizing: border-box;
        font-size: 14px;
          list-style-position :inside;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
      }
        li:nth-of-type(even) {
            background-color: #f2f2f2;
        }
    }
    .banner-all{
        height: 250px;
    }
    .banner-img{
        width: 100%;
        height: 100%;
    }
    .index-break{
        padding: 10px;
        background-color: #ededed;
    }
.company-msg{
    display: flex;
    /*justify-content: space-between;*/
    margin-top: 20px;
    padding: 0 36px;
    .company-logo{
        width: 62px;
        img{
            width: 100%;
        }
    }
    .company-name{
        margin-left: 14px;
        width: 70%;
        font-size: 16px;
        align-self: center;
    }
}
    .company-nums{
        margin-top: -12px;
        margin-right: -10px;
        border-bottom: 10px solid #ededed;
        display: flex;
        justify-content: flex-end;
        color: #aaa;
        padding: 0 36px 10px 36px;
        font-size: 14px;
        .icon-3{
            font-size: 18px;
        }
        div:nth-of-type(1){
            position: relative;
            top: -2px;
            margin-right: 10px;
        }
        .icon-fenxiang{
            font-size: 13px;
        }
    }
    .bont-ul{
        display: flex;
        font-size: 14px;
        padding: 0 20px;
        margin-top: 10px;
        li.active{
            border-radius: 4px;
            color: #fff;
            background-color: #0034e8;
        }
        li{
            text-align: center;
            color: #0034e8;
            background-color: #ffffff;
            font-weight: bold;
            padding: 5px 15px;
        }
    }
    .introduce{
        text-indent: 28px;
        font-size: 12px;
        color: #333333;
        padding: 0 20px;
        margin-top: 10px;
        height: 100px;
        line-height: 20px;
        overflow: hidden;
    }
    .active1{
      min-height: 120px;
      height: auto;
    }
    .active{
      height: auto;
    }
    .bont1{
      padding: 0 20px;
      text-align: right;
      font-size: 12px;
      color: #0034e8;
      font-weight: bold;
    }
    .bont11{
      color: #0034e8;
      padding: 0 20px;
      font-size: 12px;
      text-align: right;
      background-color: #ffffff;
      font-weight: bold;
    }
    .def-height{
        margin-top: 10px;
        height: 12px;
        background-color: #ededed;
    }
    .bakc-bont{
        position: fixed;
        display: flex;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #ffffff;
        left: 0;
        right: 0;
        bottom: 0;
        div{
            flex: 1;
        }
        .bakc-bont-left{
            background-color: #0069e9;
        }
        .bakc-bont-right{
            background-color: #0034e8;
        }
    }
    .layer-ios{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.3);
        .layer-ios-tips{
            width: 70%;
            margin: 20% auto 0 auto;
            font-size: 18px;
            color: #666666;
            background-color: #ffffff;
            padding: 30px 20px 20px 20px;
            border-radius: 6px;
        }
        .layer-ios-bont{
            font-size: 13px;
            text-align: center;
            width: 80px;
            margin: 16px auto 0 auto;
            border-radius: 4px;
            border: 1px solid #ccc;
            padding: 4px 0;
            color: #999;
        }
        .tips-icon{
            width: 58px;
            height: 58px;
            position: relative;
            top: 18px;
        }
        .icon-iconset0445{
            margin-left: 12px;
            font-size: 53px;
            position: relative;
            top: -16px;
            left: 10px;
        }
        .icon-gengduo{
            margin: 0 2px;
        }
        .tips1{
            /*margin-top: 10px;*/
        }
    }
</style>
<style>
    *{
        -webkit-user-select: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/company/preview.vue